// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"style__iconContainer__0KuSq","icon":"style__icon__RXBvM"};